/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { AppState } from "../..";

export const lanDeviceListSelector = (state: AppState) => state.deviceConfig.lanDeviceList;
export const ipInterfaceListSelector = (state: AppState) => state.deviceConfig.ipInterfaceList;
export const isAddNewLanDeviceSelector = (state: AppState) => state.deviceConfig.isAddNewLanDevice;
export const selectedLanDeviceSelector = (state: AppState) => state.deviceConfig.selectedLanDevice;
export const lanDeviceIndexesSelector = (state: AppState) => state.deviceConfig.lanDeviceIndexes;

export const isAddNewIPInterfaceSelector = (state: AppState) => state.deviceConfig.isAddNewIPInterface;
export const selectedIPInterfaceSelector = (state: AppState) => state.deviceConfig.selectedIPInterface;
export const configCountsSelector = (state: AppState) => state.deviceConfig.configCounts;
export const cconfigStatusDataSelector = (state: AppState) => state.deviceConfig.configStatusData;

//export const isAddRfFeedSelector = (state: AppState) => state.deviceConfig.isAddNewRfFeed;
export const isAddNewRfFeedSelector = (state: AppState) => state.deviceConfig.isAddNewRfFeed;
export const selectedRfFeedSelector = (state: AppState) => state.deviceConfig.selectedRfFeed;
export const rfFeedListSelector = (state: AppState) => state.deviceConfig.rfFeedList;
export const rfFeedIndexesSelector = (state: AppState) => state.deviceConfig.rfFeedIndexes;

export const zoneDeviceListSelector = (state: AppState) => state.deviceConfig.zoneDeviceList;
export const isAddNewZoneSelector = (state: AppState) => state.deviceConfig.isAddNewZoneDevice;
export const selectedZoneSelector = (state: AppState) => state.deviceConfig.selectedZoneDevice;
export const ZoneIndexesSelector = (state: AppState) => state.deviceConfig.zoneCellIndexes;
export const isZoneAddedSelector = (state: AppState) => state.deviceConfig.isZoneAdded;

//LTEX2ConnectionPeer
export const isAddNewLteX2ConnectionSelector = (state: AppState) => state.deviceConfig.isAddNewLteX2Connection;
export const selectedLteX2ConnectionSelector = (state: AppState) => state.deviceConfig.selectedLteX2Connection;
export const lteX2ConnectionListSelector = (state: AppState) => state.deviceConfig.lteX2ConnectionList;
export const lteX2ConnectionIndexesSelector = (state: AppState) => state.deviceConfig.lteX2ConnectionIndexes;

//NG2ConnectionPeer
export const isAddNewNgX2ConnectionSelector = (state: AppState) => state.deviceConfig.isAddNewNgX2Connection;
export const selectedNgX2ConnectionSelector = (state: AppState) => state.deviceConfig.selectedNgX2Connection;
export const ngX2ConnectionListSelector = (state: AppState) => state.deviceConfig.ngX2ConnectionList;
export const ngX2ConnectionIndexesSelector = (state: AppState) => state.deviceConfig.ngX2ConnectionIndexes;
export const radioUnitIndexesSelector = (state: AppState) => state.deviceConfig.radioUnitIndexes;
